module.exports = __webpack_public_path__ + "static/media/meme.5981a4b1.png";